import React, {useContext, useEffect} from "react";
import { Link, useNavigate, useSearchParams } from 'react-router';
import  { AuthContext, AuthStatus } from './authentication/context/authContext'
import Spinner from './Spinner';
import SignInButton from "./SignInButton";
import { Alert, Stack, Typography, Box } from "@mui/material";
import { theme } from 'theme/create-theme';
import { LOGOS } from "theme/core";
import intl from 'components/i18n/ReactIntlWrapper';



export const PageLogin = () => {
    const { authStatus } = useContext(AuthContext)
    const isAuthenticated = authStatus === AuthStatus.SignedIn;
    const navigate = useNavigate();

    //get sessionExpired parameter from URL
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if(isAuthenticated){
            navigate('/');
        }
    }, [authStatus])

    return (
        <Box sx={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {authStatus === AuthStatus.Loading ? (
                <Spinner/>
            ) : (
                <Stack sx={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4, backgroundColor: theme.palette.primary.main}}>
                    {searchParams.get('sessionExpired') && (
                        <Alert variant="standard" severity="warning">
                            Your session has expired. Please sign in again.
                        </Alert>
                    )}
                    <div>
                        <Typography variant="h5" color="common.white" mb={2} align="center">{intl.get('pageLogin.welcomeTo')}</Typography>
                        <Box mb={5}>
                            <img src={LOGOS.FULL_WHITE.src} width={300}/>
                        </Box>
                        <SignInButton/>
                        <Typography variant="caption" color="common.white" mt={10} display="flex" justifyContent="center">
                            A&nbsp;<Link to="#" style={{
                                color: theme.palette.common.white,
                                textDecoration: 'none',
                                fontWeight: 'bold',
                            }}>{intl.get('pageLogin.borderlessSoftware')}</Link>&nbsp;product. 
                        </Typography>
                         <Typography variant="caption" color="common.white" mt={0} display="flex" justifyContent="center">
                            All rights reserved @ 2025
                        </Typography>

                    </div>
                </Stack>
            )}
        </Box>
    );
}
